// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3XSRH","productName":"Table_productName__2ACuB"};